export const apiQueryKeys = {
  getPlanCards: ['getPlanCards'],
  addressSearch: ['addressSearch'],
  serviceQualification: ['serviceQualification'],
  newDevelopmentCharge: ['NewDevelopmentCharge'],
  me: (customerId: string | null) => ['me', 'AUTH_REQUIRED', customerId],
};
